module.exports = __webpack_public_path__ + "img/位图备份_18.3a2b31ab.jpg";